import { getSaturnMessages, markAsRead as markAsReadApi, archive as archiveApi } from '@core/services/api/api.messages';
import { defineStore } from 'pinia';
import { DocAssociation } from '@core/classes/SharedEnums';
import { ref } from 'vue';
import { SaturnAssociation } from '@core/classes/SaturnAssociation';
import { SaturnMessage } from '@core/classes/SaturnMessage';

export const useMessagesStore = defineStore('messages', () => {
	const dealMessages = ref<SaturnMessage[]>([]);

	// Soft usage methods
	const setDealMessages = (messages: SaturnMessage[]) => {
		dealMessages.value = messages;
	};

	const addDealMessage = (message: SaturnMessage) => {
		dealMessages.value.push(message);
	};

	const getDealMessages = () => {
		return dealMessages.value ?? [];
	};

	// Methods that should not be used lightly
	const loadDealMessages = async (dealId: string) => {
		const associations = [
			new SaturnAssociation({
				type: DocAssociation.Deal,
				id: dealId,
			}),
		];
		try {
			const response = await getSaturnMessages(associations);
			setDealMessages(response.data?.payload ?? []);
		} catch (error) {
			console.error(error, 'Error fetching deal messages');
		}
	};

	const markAsRead = async (messageId: string) => {
		try {
			await markAsReadApi(messageId);
		} catch (error) {
			console.error(error, 'Error marking message as read');
		}
	};

	const archive = async (messageId: string) => {
		try {
			await archiveApi(messageId);
		} catch (error) {
			console.error(error, 'Error archiving message');
		}
	};

	return {
		dealMessages,
		setDealMessages,
		addDealMessage,
		getDealMessages,
		loadDealMessages,
		markAsRead,
		archive,
	};
});
